"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = _interopRequireDefault(require("../Hubs/epics"));

var _epics2 = require("../Channels/epics");

var _epics3 = _interopRequireDefault(require("../Domains/epics"));

var _epics4 = require("../Owners/epics");

var _epics5 = require("../Users/epics");

var _epics6 = require("../Sitemaps/epics");

var _epics7 = require("../PagesForSitemaps/epics");

var _epics8 = _interopRequireDefault(require("../Properties/epics"));

var _epics9 = _interopRequireDefault(require("../UserAppAttributes/epics"));

var _epics10 = _interopRequireWildcard(require("../PortalSettings/epics"));

var _epics11 = _interopRequireDefault(require("../UserSettings/epics"));

var _epics12 = require("../SupportedLanguages/epics");

var _epics13 = _interopRequireDefault(require("../I18n/epics"));

var _epics14 = _interopRequireDefault(require("../Iris/epics"));

var _epics15 = _interopRequireDefault(require("../OptIn/epics"));

var _epics16 = require("../Themes/epics");

var _default = (0, _reduxObservable.combineEpics)(_epics2.fetchChannels, _epics3.default, _epics4.fetchOwners, _epics5.fetchPayload, _epics6.fetchSitemaps, _epics6.updateSitemap, _epics7.fetchIncludedPagesForSitemap, _epics7.fetchExcludedPagesForSitemap, _epics8.default, _epics9.default, _epics.default, _epics10.default, _epics10.stageAndSavePortalSetting, _epics11.default, _epics12.fetchSupportedLanguages, _epics13.default, _epics14.default, _epics15.default, _epics16.fetchThemes);

exports.default = _default;
module.exports = exports.default;